import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'

import Col from '~shared/components/MuiGrid/Col'
import Row from '~shared/components/MuiGrid/Row'
import { useGlobalStyles } from '~shared/styles/globalStyles'

const Success: React.FC = () => {
  const gs = useGlobalStyles()
  const { t } = useTranslation()

  return <>
    <Row spacingTop={3}>
      <Col>
        <Typography variant='h4' component='h1' style={{ marginBottom: '1rem' }}>
          {t('form:newUserFormStepSuccessHeading')}
        </Typography>
        <Typography className={gs.marginBottomSmall}>
          {t('form:newUserFormStepSuccessText')}
        </Typography>
      </Col>
    </Row>
  </>
}

export default Success
